export const visit = (vm, at) => {
vm(require("foundations-components/lang/bn.lyaml"));
at({ "bn": { "placeholder": "\u09AA\u09CD\u09B2\u09C7\u09B8\u09B9\u09CB\u09B2\u09CD\u09A1\u09BE\u09B0" } });
};